import { create } from 'zustand';
import { DEFAULT_LABOR_CONFIG } from '../utils/laborUnit.utils';
import type { PresetConfig } from '../types/laborUnit.types';

type LaborPercentagesState = {
  storedPercentages: Omit<PresetConfig, 'name' | 'description'>;
  storedNotes: string;
  setStoredPercentages: (percentages: Omit<PresetConfig, 'name' | 'description'>) => void;
  setStoredNotes: (notes: string) => void;
  setStoredData: (percentages: Omit<PresetConfig, 'name' | 'description'>, notes: string) => void;
  resetToDefault: () => void;
};

export const useLaborPercentagesStore = create<LaborPercentagesState>(set => ({
  storedPercentages: {
    layoutPct: DEFAULT_LABOR_CONFIG.layoutPct,
    materialPct: DEFAULT_LABOR_CONFIG.materialPct,
    nonProductivePct: DEFAULT_LABOR_CONFIG.nonProductivePct,
    toolHandlingPct: DEFAULT_LABOR_CONFIG.toolHandlingPct,
  },
  storedNotes: '',
  setStoredPercentages: percentages => set({ storedPercentages: percentages }),
  setStoredNotes: notes => set({ storedNotes: notes }),
  setStoredData: (percentages, notes) =>
    set({ storedPercentages: percentages, storedNotes: notes }),
  resetToDefault: () =>
    set({
      storedPercentages: {
        layoutPct: DEFAULT_LABOR_CONFIG.layoutPct,
        materialPct: DEFAULT_LABOR_CONFIG.materialPct,
        nonProductivePct: DEFAULT_LABOR_CONFIG.nonProductivePct,
        toolHandlingPct: DEFAULT_LABOR_CONFIG.toolHandlingPct,
      },
      storedNotes: '',
    }),
}));
